export const formatDelayField = (value: unknown, emptyLabel = "—") => {
  if (value === null || value === undefined || `${value}`.trim() === "") {
    return emptyLabel;
  }
  return `${value}`;
};
